import request from '@/utils/request'

// 分组查询某分类的产品参数模板
export function paramTemplateList(data) {
  return request({
    url: '/biz/admin/goods/param-template/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}

// 按平台商品分类批量查询生效的产品参数模板(含父分类继承)
export function paramTemplateByCategory(data) {
  return request({
    url: '/biz/admin/goods/param-template/by-category',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}

// 新增产品参数模板
export function addParamTemplate(data) {
  return request({
    url: '/biz/admin/goods/param-template/add',
    method: 'post',
    data: data
  })
}

// 编辑产品参数模板
export function updateParamTemplate(data) {
  return request({
    url: '/biz/admin/goods/param-template/edit',
    method: 'post',
    data: data
  })
}

// 删除产品参数模板
export function delParamTemplate(data) {
  return request({
    url: '/biz/admin/goods/param-template/delete',
    method: 'post',
    data: data
  })
}

// 从其他分类复制产品参数模板
export function copyParamTemplate(data) {
  return request({
    url: '/biz/admin/goods/param-template/copy',
    method: 'post',
    data: data
  })
}
